import EditHolisticProject from './EditHolisticProject';

export default EditHolisticProject;
